<template>
  <div class="page">
    <div :class="pageCls">
      <div class="d1"></div>
      <div class="d2">
        <div class="b1"></div>
      </div>
      <div class="d3">
        <div class="b1"></div>
      </div>
      <div class="d4">
        <div class="b1"></div>
      </div>
      <div class="d5"></div>
      <div class="d6"></div>
      <div :class="txtStatus==2 ? 'd7' : 'd7 d7_2'">
        <div class="t1"></div>
        <div class="t2"></div>
        <div class="t3"></div>
        <div class="t4"></div>
        <div class="t5"></div>
        <div class="t6"></div>
        <div class="t7"></div>
      </div>
      <div class="d8"></div>
    </div>
    <div id="qianduanwz" class="qianduanwz">
      <img class="bg" :src="Tool.pubPach+'end/e'+userData.sel1+'_'+userData.pic+'.png'" >
      <div class="tx">
        <img :src="userData.me.tx" >
      </div>
      <div class="name">{{userData.me.name}}</div>
      <div class="num">{{userData.juNum}}</div>
      <img class="ewm" :src="Tool.pubPach+'end/ewm.png'" >
    </div>
  </div>
</template>

<script>
import Tool from '../script/tool.js'
const rsArr = [
  {
    1 : 3,
    2 : 5,
    3 : 2,
    4 : 4,
    5 : 1,
    6 : 7,
    7 : 8,
    8 : 6,
  },{
    1 : 4,
    2 : 6,
    3 : 5,
    4 : 8,
    5 : 7,
    6 : 2,
    7 : 3,
    8 : 1,
  },{
    1 : 2,
    2 : 1,
    3 : 5,
    4 : 4,
    5 : 3,
    6 : 7,
    7 : 8,
    8 : 6,
  }
];
export default {
  name: 'Page5',
  props: {
    userData: Object
  },
  data(){
    return{
      pageCls:"page5",
      Tool:Tool,
      txtStatus:1,
    }
  },
  mounted(){
    let that = this;
    let temTime = new Date().getTime();
    let num = this.countDis();
    this.$emit('setUser',"juNum",num);
    this.$emit('setPic');
    // console.log(this.userData)
    setTimeout(() => {
      (window.html2canvas || html2canvas)(document.getElementById('qianduanwz'),{
        dpi: 300,
        allowTaint: true,
        useCORS: true 
      }).then(function(canvas) {
        that.$emit('setUser',"base64",canvas.toDataURL());
        let tem2 = new Date().getTime() - temTime - 14000;
        // return that.$emit('setPage',6);
        if(tem2 >= 0){
          that.$emit('setPage',6);
        }else{
          setTimeout(() => {
            that.$emit('setPage',6);
          }, -tem2);
        }
      });
    }, 1000);
  },
  methods:{
    countDis(){
      //（位置加权✖人设赋值）➗车内人数
      let tem = 0;
      for(let i=0;i<this.userData.sel2.length;i++){
        // console.log(this.userData.sel3[this.userData.sel2[i]])
        // console.log(this.wzNum(this.userData.sel3[this.userData.sel2[i]]))
        let w = this.wzNum(this.userData.sel3[this.userData.sel2[i]]);
        let r = rsArr[this.userData.sel1-1][this.userData.sel2[i]];
        // console.log(w,r,w*r)
        if(this.userData.sel3[this.userData.sel2[i]] == 5 || this.userData.sel3[this.userData.sel2[i]]==6){
          this.txtStatus=2;
        }
        tem +=  w*r;
      }
      // console.log(tem)
      tem = tem / this.userData.sel2.length;
      tem = parseInt(tem * 10)/10;
      if((""+tem).indexOf(".")==-1){
        tem+='.0';
      }
      // console.log(tem);
      return tem;
    },
    wzNum(n){
      //第一排 3 第二排 2 第三排 1 
      if(n == 1){
        return 3;
      }
      if(n == 2 || n == 3 || n == 4){
        return 2;
      }
      return 1;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$time:0.75;
$time2:2.5;
.page{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
}
.page5{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  z-index: 2;
  background: #eee url(../assets/bg01.png) no-repeat 0 0 / 100% 100%;
  .d1{
    position: absolute;
    left:50%;
    top:0;
    bottom:0;
    width: 6.6rem;
    margin-left:-3.3rem;
    background: #eee;
    border:1px solid #1b1b1b;
    border-width: 0 1px;
  }
  .d2,.d3{
    position: absolute;
    left:0;
    top:0;
    bottom:0;
    width: 0.21rem;
    .b1{
      &::before{
        content: '';
        position: absolute;
        left:0;
        top:0;
        width: 0.21rem;
        height: 23rem;
        background: url(../assets/bg82.png) repeat-y 0 0 / 100% auto;
        transform: translateY(-2.3rem);
        animation:0.7s 2s linear infinite transformAni2;
      }
    }
  }
  .d3{
    left:auto;
    right:0;
  }
  .d4{
    position: absolute;
    left:50%;
    top:50%;
    width: 3.62rem;
    height: 6.18rem;
    margin:-5.72rem 0 0 -1rem;
    transform: translateY(100vh);
    animation:1.5s linear 1 transformAni2;
    animation-fill-mode: forwards;
    .b1{
      position: absolute;
      left:0;
      top:0;
      width: 100%;
      height: 100%;
      background: url(../assets/bg85.png) repeat-y 0 0 / 100% auto;
      transform: translateX(-1.5rem);
      animation:4s 2s linear infinite transformAni;
      &::before{
        content: '';
        position: absolute;
        left:-0.51rem;
        bottom:0.65rem;
        width: 4.63rem;
        height: 2.92rem;
        background: url(../assets/bg86.png) repeat-y 0 0 / 100% auto;
        opacity: 0;
        animation:$time+s 2s linear 1 opacityAni2;
        animation-fill-mode: forwards;
      }
    }
  }
  .d5{
    position: absolute;
    right:0.55rem;
    top:50%;
    width: 0.51rem;
    height: 4.71rem;
    margin:-3.7rem 0 0 0;
    background: url(../assets/bg84.png) repeat-y 0 0 / 100% auto;
    opacity: 0;
    animation:$time+s $time*8+$time2+s linear 1 opacityAni2;
    animation-fill-mode: forwards;
  }
  .d6{
    position: absolute;
    left:0.9rem;
    top:50%;
    width: 5.72rem;
    height: 1.07rem;
    margin:-5.05rem 0 0 0;
    background: url(../assets/bg83.png) repeat-y 0 0 / 100% auto;
    opacity: 0;
    animation:$time+s $time2+s linear 1 opacityAni2;
    animation-fill-mode: forwards;
  }
  .d7{
    position: absolute;
    left:50%;
    top:50%;
    width: 3.73rem;
    height: 4.02rem;
    margin:1.05rem 0 0 -1.865rem;
    div{
      position: absolute;
      left:0;
      top:0;
      width: 100%;
      height: 0.4rem;
      background: url(../assets/bg88.png) no-repeat 0 0 / 100% auto;
      opacity: 0;
      animation:$time+s $time+$time2+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    .t2{
      top:0.5rem;
      background-position: 0 -0.5rem;
      animation-delay:$time*2+$time2+s;
    }
    .t3{
      top:1.05rem;
      background-position: 0 -1.05rem;
      animation-delay:$time*3+$time2+s;
    }
    .t4{
      top:1.6rem;
      background-position: 0 -1.6rem;
      animation-delay:$time*4+$time2+s;
    }
    .t5{
      top:2.6rem;
      background-position: 0 -2.6rem;
      animation-delay:$time*5+$time2+s;
    }
    .t6{
      top:3.2rem;
      background-position: 0 -3.2rem;
      animation-delay:$time*6+$time2+s;
    }
    .t7{
      top:3.7rem;
      background-position: 0 -3.7rem;
      animation-delay:$time*7+$time2+s;
    }
  }
  .d7_2{
    position: absolute;
    left:50%;
    top:50%;
    width: 3.6rem;
    height: 3.48rem;
    margin:1.05rem 0 0 -1.8rem;
    div{
      position: absolute;
      left:0;
      top:0;
      width: 100%;
      height: 0.4rem;
      background: url(../assets/bg105.png) no-repeat 0 0 / 100% auto;
      opacity: 0;
      animation:$time+s $time+$time2+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    .t2{
      top:0.5rem;
      background-position: 0 -0.5rem;
      animation-delay:$time*2+$time2+s;
    }
    .t3{
      top:1.05rem;
      background-position: 0 -1.05rem;
      animation-delay:$time*3+$time2+s;
    }
    .t4{
      top:2.08rem;
      background-position: 0 -2.08rem;
      animation-delay:$time*4+$time2+s;
    }
    .t5{
      top:2.66rem;
      background-position: 0 -2.66rem;
      animation-delay:$time*5+$time2+s;
    }
    .t6{
      top:3.2rem;
      background-position: 0 -3.2rem;
      animation-delay:$time*6+$time2+s;
    }
  }
  .d8{
    position: absolute;
    left:50%;
    top:50%;
    width: 3.82rem;
    height: 1.42rem;
    margin:0.4rem 0 0 -1.91rem;
    background: url(../assets/bg87.png) repeat-y 0 0 / 100% auto;
    opacity: 0;
    animation:$time+s $time*9+$time2+s linear 1 opacityAni2;
    animation-fill-mode: forwards;
  }
}



// #qianduanwz{
//   position: absolute;
//   left:0;
//   top:0;
//   width: 750px;
//   height: 1448px;
//   .bg{
//     position: absolute;
//     left:0;
//     top:0;
//     width: 100%;
//     height: 100%;
//   }
//   .tx{
//     position: absolute;
//     left:24px;
//     top:109px;
//     width: 136px;
//     height: 102px;
//     background: url(../assets/bg93.png) no-repeat 0 0 / 100% 100%;
//     img{
//       position: absolute;
//       left: 22px;
//       top: 2px;
//       width: 97px;
//       height: 97px;
//       border-radius: 100%;
//     }
//     &::after{
//       content: '';
//       position: absolute;
//       left: 0;
//       top: 42px;
//       width: 136px;
//       height: 43px;
//       background: url(../assets/bg94.png) no-repeat 0 0 / 100% 100%;
//     }
//   }
//   .name{
//     position: absolute;
//     left:185px;
//     top:106px;
//     width: 360px;
//     font-size: 40px;
//     line-height: 80px;
//     height: 80px;
//     text-align: left;
//     white-space:nowrap;
//     overflow:hidden;
//     text-overflow:ellipsis;
//   }
//   .num{
//     position: absolute;
//     right:0;
//     top:327px;
//     top: 397px;
//     right: -71px;
//     width: 300px;
//     font-size: 110px;
//     line-height: 158px;
//     height: 158px;
//     white-space:nowrap;
//     overflow:hidden;
//     text-overflow:ellipsis;
//     transform: rotate(90deg);
//   }
//   .ewm{
//     position: absolute;
//     left:0;
//     bottom:0;
//     width: 750px;
//     height: 230px;
//   }
// }
</style>
